// @flow
import { combineReducers } from 'redux';
import idealistDayEvents from './idealistDayEvents';
import type { Action as IdealistDayEventsAction } from '../../actions/userDashboard/idealistDayEvents';

const reducers = { idealistDayEvents };

export default combineReducers<typeof reducers, IdealistDayEventsAction>(
  reducers
);
